export default {
  'cdnResources.list.deleteCdn.message': '刪除成功',
  'cdnResources.list.columns.Tag.suspend': '暫停',
  'cdnResources.list.Popconfirm.title': '您確定刪除該CDN資源嗎？',
  'cdnResources.list.Popconfirm.okText': '是的',
  'cdnResources.list.Popconfirm.cancelText': '不，取消',
  'cdnResources.list.Modal.Cancel': '取消',
  'cdnResources.list.title': 'CDN資源',
  'cdnResources.list.Create.ResourceName': '資源名稱',
  'cdnResources.list.Create': '創建新的CDN資源',
  //v1.2.0
  'cdnResources.list.ConfirmAndCreate': '確認並創建',
  'cdnResources.list.Create.Disabled': '已達到上限',
  'cdnResources.list.Empty.btnText': '開始加速',
  'cdnResources.list.Empty.desc': '3分鐘創建資源，開啟加速',
  'cdnResources.list.columns.title1': 'CDN加速域名',
  'cdnResources.list.columns.title2': 'CNAME',
  'cdnResources.list.columns.title3': '來源',
  'cdnResources.list.columns.title4': '操作選項',
  'cdnResources.list.columns.title7': '來源類型',
  //v1.2.0
  'cdnResources.list.columns.title5': '檔位',
  'cdnResources.list.columns.title6': '本月用量',
  'cdnResources.list.PopoverText1': '數據詳情',
  'cdnResources.list.PopoverText2': '設置',
  'cdnResources.list.PopoverText3': '刪除資源',
  'cdnResources.list.PopoverText4': '清除所有緩存',
  //v1.3.3
  'cdnResources.create.stepBox.step0': '填寫資源信息',
  'cdnResources.create.stepBox.step1': '選擇檔位',
  'cdnResources.create.step0.title1': '創建加速資源',
  'cdnResources.create.step0.title2': '獲取來源',
  'cdnResources.create.step0.type1': '源URL',
  'cdnResources.create.step0.type2': '對象存儲',
  'cdnResources.create.step0.sourceHostName': '回源主機名',
  'cdnResources.create.step0.sourceHostName.text':
    '回源主機名的選擇影響到請求源站時接收到的域名。默認類型僅供參考，',
  'cdnResources.create.step0.btn': '去選擇您的節點檔位',

  'cdnResources.create.step1.fristFree': '前{val}免費',
  // 'cdnResources.create.stepBox.step1': '基礎設置',
  'cdnResources.create.stepBox.step2': '完成',
  'cdnResources.create.onSubmit.message': '創建成功',
  'cdnResources.create.step1.validatorCdnHostName.same': 'CDN加速域名和源是一樣的',
  'cdnResources.create.step1.Form.cdnHostName.name': 'CDN加速域名',
  'cdnResources.create.step1.Form.cdnHostName.message': '請輸入您的CDN加速域名！',
  'cdnResources.create.step1.Form.origin.protocol': '源政策',
  'cdnResources.create.step1.Form.origin.name': '來源',
  'cdnResources.create.step1.Form.origin.message': '請輸入源！',
  'cdnResources.create.step1.Form.Checkbox.name': '使用自定義端口',
  'cdnResources.create.step1.Form.port.name': '端口（非必填）',
  'cdnResources.create.step1.Form.port.message': '請輸入端口號！',
  'cdnResources.create.step1.Form.port.80': '80通常是HTTP協議端口，請確認源站協議選擇是否正確。',
  'cdnResources.create.step1.Form.port.443': '443通常是HTTPS協議端口，請確認源站協議選擇是否正確。',
  'cdnResources.create.step2.message': '創建成功',
  'cdnResources.create.step2.title1': 'CDN資源已成功創建，CNAME將在',
  'cdnResources.create.step2.title2': '秒內生成',
  'cdnResources.create.step1.tip1':
    '您要加速的網址通常是對用戶開放的公開顯示地址。 完成後，您可以使用我們的 CNAME 或您的顯示地址來加速您的資源。',
  'cdnResources.create.step1.tip2': '您要加速的網址通常是對用戶開放的公開顯示地址。',
  'cdnResources.create.step1.tip2.1': '在此處填寫web內容源的地址，可以是URL或IP。',
  'cdnResources.create.step1.tip3': '(註意URL格式：{domain1}、 {domain2}，不支持{domain3}）',
  'cdnResources.create.step1.tip3.0':
    '完成後，您可以使用我們的 CNAME 或您的顯示地址來加速您的資源。請註意一行一個CDN加速域名。',
  'cdnResources.create.step1.tip3.1': '註意URL格式：',
  'cdnResources.create.step1.tip4': '來源政策為AUTO時，不支持填寫端口。',
  'cdnResources.create.step1.tip5': '（泛域名需要單獨創建）',
  'cdnResources.create.step1.tip6': '泛域名需要單獨創建',
  'cdnResources.create.step1.NotSupported': '（暫時不支持）',
  'cdnResources.create.step1.help1': '如果你需要更多幫助，你可以 ',
  'cdnResources.create.step1.help2': '點擊這裏。',
  'cdnResources.create.step1.origin.note1': '請註意：',
  'cdnResources.create.step1.origin.note2': '多源僅能以IP的格式填寫。',
  'cdnResources.create.step1.origin.message': '超過一條源時，僅可使用IP地址。',
  'cdnResources.create.step1.origin.validatorMessage1': '請填寫有效的源。',
  'cdnResources.create.step1.origin.validatorMessage2': '請填寫有效的加速域名。',
  'cdnResources.create.step1.origin.validatorMessage3': '這個IP地址已存在。',
  'cdnResources.create.step1.origin.validatorMessage4': '請填寫有效的IP地址。',
  'cdnResources.create.step1.origin.validatorMessage5': '多源时，端口号必须一致。',
  'cdnResources.create.step1.origin.validatorMessage6': '當前加速域名不可創建。',
  'cdnResources.create.step1.origin.validatorMessage7': '請輸入最多 10 個 IP',
  'cdnResources.create.step1.origin.unique': '源已經存在',
  'cdnResources.create.step1.hostname.unique': 'CDN加速域名已存在。',
  'cdnResources.create.step1.resourceName.unique': '資源名稱已存在。',
  //v1.2.0
  'cdnResources.create.StandardNetwork': '標準網絡',
  'cdnResources.create.CoreNetwork': '核心網絡',
  'cdnResources.create.noPlan.modal.text': '余額不足&沒有計劃',
  'cdnResources.create.noPlan.modal.p': '您還有免費流量可以兌換！',
  'cdnResources.create.noPlan.modal.button': '獲取方案',
  'cdnResources.create.No.additional': '無額外收費。',
  'cdnResources.detail.tabKey4.tier.Current': '當前檔位',
  'cdnResources.detail.tabKey4.tier.edit': '更換檔位',
  'cdnResources.detail.tabKey4.tier.Usage': '本月用量',
  'cdnResources.detail.tabKey4.tier.Unitprice': '單價',
  'cdnResources.detail.tabKey4.EnableEdgeLocation': '開啟邊緣位置',
  'cdnResources.detail.tabKey4.tier.Modal.p1': '您當前沒有此邊緣位置的權限。請切換層，然後重試。',
  'cdnResources.detail.tabKey4.tier.Recommended': '推薦檔位：',
  'cdnResources.create.NetworkList.moreFavorable': '點擊此處獲取更優惠的價格',
  'cdnResources.create.title.resources': '創建您的CDN資源',
  'cdnResources.create.title.tier': '選擇您的檔位',
  'cdnResources.create.tier.loading': '正在為你處理資源，請等待...',
  'cdnResources.create.NetworkList.tierRecharge.p1': '以下檔位需要確保余額充足，',
  'cdnResources.create.NetworkList.tierRecharge.p2': '请前往充值',
  'cdnResources.create.NetworkList.planLearn.p1':
    '您當前有一個月度計劃，該計劃將自動激活相應的檔位。',
  'cdnResources.create.NetworkList.planLearn.p2': '了解你的月度計劃',
  'cdnResources.create.postpaid.price.p':
    '如果半小時的流量極小，我們將扣除0.000001美元的最低金額。如果超過此金額，我們將根據正常計費扣除。',
  'cdnResources.detail.NoPermission': '無權限',
  'cdnResources.detail.SuggestedTier': '建議檔位：',

  'cdnResources.detail.title': 'CDN資源',
  'cdnResources.detail.tabKey1': '基礎設置',
  'cdnResources.detail.tabKey2': '高級設置',
  'cdnResources.detail.tabKey3': '加速位置',
  'cdnResources.detail.tabKey4': '清除',
  'cdnResources.detail.tabKey5': '預存',
  'cdnResources.detail.tabKey6': '激活配置',
  'cdnResources.detail.tabKey7': '安全保护',
  'cdnResources.detail.tabKey8': '規則集',
  'cdnResources.detail.tabKey9': '性能優化',
  'cdnResources.detail.tabKey1.onSuccess.message': '更新成功',
  'cdnResources.detail.tabKey1.title': '基礎信息',
  'cdnResources.detail.tabKey1.cdnHostName.name': 'CDN加速域名',
  'cdnResources.detail.tabKey1.cdnHostName.message': '請輸入',
  'cdnResources.detail.tabKey1.cdnHostName.placeholder': '每個CDN加速域名都需要填寫一行，最多15行',
  'cdnResources.detail.tabKey1.cdnHostName.validatorMessage': '請輸入有效的主機名。',
  // 'cdnResources.detail.tabKey1.origin.name': 'Origin',
  'cdnResources.detail.tabKey1.port.name': '端口',
  'cdnResources.detail.tabKey1.select.message': '請選擇',
  'cdnResources.detail.tabKey1.Button': '新增',
  'cdnResources.detail.tabKey1.https.title': 'HTTPS配置',
  'cdnResources.detail.tabKey1.https.alert':
    '請註意，當前資源綁定的以下域名尚未配置證書，將無法通過HTTPS協議訪問：',
  'cdnResources.detail.tabKey1.https.TLS.title': 'TLS最低版本',
  'cdnResources.detail.tabKey1.https.TLS.tip':
    'TLS的選擇上，建議使用TLS1.2或1.3。當前1.0和1.1的版本存在已知漏洞，應該避免使用。',
  'cdnResources.detail.tabKey1.https.HTTP2.title': '啟用HTTP/2',
  'cdnResources.detail.tabKey1.https.HTTP2.tip':
    '開啟HTTP/2 能顯著提升性能改善用戶體驗。註意確保配置了正確的證書的情況下，才能生效。',
  'cdnResources.detail.tabKey1.ssl.title': 'SSL',
  'cdnResources.detail.tabKey1.ssl.Tag1': '已啟用',
  'cdnResources.detail.tabKey1.ssl.Tag2': '未啟用',
  'cdnResources.detail.tabKey1.ssl.tip':
    '加速域名必須具有SSL證書，才能通過HTTPS訪問。您可以打開SSL證書來配置域名。',
  'cdnResources.detail.tabKey1.ssl.tip1':
    '若你有多個CDN加速域名，可以選擇上傳多個對應的SSL證書，或通配符證書來確保所有加速域名都可以通過HTTPS訪問。',
  'cdnResources.detail.tabKey1.ssl.tip11': '請確保您的',
  'cdnResources.detail.tabKey1.ssl.tip22': '所有',
  'cdnResources.detail.tabKey1.ssl.tip33': 'CDN主機名都已解析為CNAME，否則免費證書將無法打開。',
  'cdnResources.detail.tabKey1.ssl.group.label1': "Let's Encrypt",
  'cdnResources.detail.tabKey1.ssl.group.p1':
    "請輸入完成的主機名，並確保它不以'.cdn95.com'結尾，不然他將無法自動開啟SSL證書。",
  'cdnResources.detail.tabKey1.ssl.group.label2': '自定義 SNI SSL',
  'cdnResources.detail.tabKey1.ssl.group.p2':
    '若開啟輔助加速域名，自定義SNI證書將同時作用於加速域和輔助加速域。',
  'cdnResources.detail.tabKey1.HostName.title': '輔助加速域名',
  'cdnResources.detail.tabKey1.HostName.modal.title': '保存',
  'cdnResources.detail.tabKey1.HostName.modal.text1':
    "如果你開啟了輔助加速域名，我們將自動為你切換或開啟Let's Encrypt SSL證書。",
  'cdnResources.detail.tabKey1.HostName.modal.text2': '請確認是否需要開啟輔助加速域名？',
  'cdnResources.detail.tabKey1.HostName.message1': '可以填寫的CDN加速域名已超過上限！',
  'cdnResources.detail.tabKey1.HostName.message2': '不可重復或跟CDN加速域名相同。',
  'cdnResources.detail.tabKey1.HostName.message3': '填寫的域名不可跟加速域相同。',
  'cdnResources.detail.tabKey1.HostName.message4': '不可重復或與CDN加速域名相同。', //和輔助CDN加速域名
  'cdnResources.detail.tabKey1.HostName.message5': '不可重復或跟源相同。',
  'cdnResources.detail.tabKey1.HostName.message6': '不可重復。',
  'cdnResources.detail.tabKey1.HostName.tip0.0':
    '若你使用的是免費證書，在加速域名變更並確保新域名cname解析完成後，需要重新關閉開啟免費證書以確保證書同步給新的域名。',
  'cdnResources.detail.tabKey1.HostName.tip0':
    'CDN 加速域名支持添加多個。請註意一行一個CDN加速域名。',
  'cdnResources.detail.tabKey1.HostName.tip1':
    'CDN輔助域支持添加多個加速域名，用戶可以利用並行下載來加快頁面加載速度。您需要為CDN主機名和輔助CDN主機名稱設置CNAME。更多詳情',
  'cdnResources.detail.tabKey1.HostName.tip2': '查看文檔',
  'cdnResources.detail.tabKey1.origin.toRules': '有關更多源設置，請訪問',
  'cdnResources.detail.tabKey2.tip.name': '如何繞過 LightCDN 的邊緣服務器直接訪問源呢？',
  'cdnResources.detail.tabKey2.tip.pop': '點擊進入引導',
  'cdnResources.detail.tabKey2.tip.content':
    '你可以嘗試為特定的文件將具有 Cache-Control 標頭的CDN資源的緩存規則添加為「no-cache」或者「max-age = 0」。同時，您可以將Force Edge設置為從不緩存，這將強製CDN邊緣服務器在緩存規則中從不緩存請求。',
  'cdnResources.detail.tabKey2.HLS_force_cache.name': 'HLS 強製緩存',
  'cdnResources.detail.tabKey2.HLS_force_cache.p1':
    '強製m3u8文件邊緣服務器不緩存並支持設置過期時間。 該設置僅在啟用',
  'cdnResources.detail.tabKey2.HLS_force_cache.p2': '「HLS優化」',
  'cdnResources.detail.tabKey2.HLS_force_cache.p3': '時生效。',
  'cdnResources.detail.tabKey2.title': '緩存過期時間',
  'cdnResources.detail.tabKey2.Modal.title': '添加SSL證書',
  'cdnResources.detail.tabKey2.cacheExpiry.name': '緩存有效期',
  'cdnResources.detail.tabKey2.cacheExpiry.message': '請輸入緩存有效期！',
  'cdnResources.detail.tabKey2.cacheExpiry.fieldProps': '分鐘 (默認12天)',
  'cdnResources.detail.tabKey2.cacheExpiry.default': '默認',
  'cdnResources.detail.tabKey2.cacheExpiry404.name': '404狀態碼的緩存有效期',
  'cdnResources.detail.tabKey2.cacheExpiry404.fieldProps': '1分鐘 (默認)',
  'cdnResources.detail.tabKey2.cacheExpiry.tip1':
    '當前緩存時間為針對全站的緩存，當你擁有動態內容時，',
  'cdnResources.detail.tabKey2.cacheExpiry.tip2': '該如何確保動態內容不被緩存呢？ →',
  'cdnResources.detail.tabKey2.rules.title': '配置',
  'cdnResources.detail.tabKey2.originPolicy.name': '來源政策',
  'cdnResources.detail.tabKey2.originPolicy.label1': '自動',
  'cdnResources.detail.tabKey2.originPolicy.label2': 'HTTP',
  'cdnResources.detail.tabKey2.originPolicy.label3': 'HTTPS',
  'cdnResources.detail.tabKey2.originPolicy.tip1':
    'LightCDN的來源政策選項允許您設置從CDN邊緣服務器到源服務器的拉取請求的協議。你可以',
  'cdnResources.detail.tabKey2.originPolicy.tip2': '查看文檔',
  'cdnResources.detail.tabKey2.originPolicy.tip3': '來了解更多。',
  'cdnResources.detail.tabKey2.originPolicy.p1':
    'HTTP—邊緣服務器和始終使用HTTP的源之間的連接。它是默認值。',
  'cdnResources.detail.tabKey2.originPolicy.p2': 'HTTPS—邊緣服務器和始終使用HTTPS的源之間的連接。',
  'cdnResources.detail.tabKey2.originPolicy.p3':
    'AUTO—基於訪問者請求（HTTP或HTTPS）的邊緣服務器和源服務器之間的連接。但請註意，當您的源已填寫端口時，無法選擇AUTO。',
  'cdnResources.detail.tabKey2.corsOn.name': 'CORS 標頭',
  'cdnResources.detail.tabKey2.corsOn.p1':
    '啟用後，通過添加具有訪問控製允許源的HTTP標頭來啟用跨域資源共享（CORS）。',
  'cdnResources.detail.tabKey2.corsOn.p2':
    "若開啟後，訪問加速域名報錯，「No 'Access-Control-Allow-Origin' header is present on the requested resource.」 ，可",
  'cdnResources.detail.tabKey2.corsOn.p3': '查看文檔',
  'cdnResources.detail.tabKey2.corsOn.p4': '看具體解決方式。',
  'cdnResources.detail.tabKey2.RedirectHttp.name': '將客戶端從HTTP重定向到HTTPS',
  'cdnResources.detail.tabKey2.RedirectHttp.p1':
    '開啟後，所有HTTP的請求都會自動跳轉到對應的HTTPS URL上，端口號：',
  'cdnResources.detail.tabKey2.hostHeaderForwarding.name': '主機標頭轉發',
  'cdnResources.detail.tabKey2.hostHeaderForwarding.p1': `CDN邊緣服務器僅在邊緣服務器中不存在文件（緩存）時（對於所有場景）才返回原始位置，並且在從CDN邊緣-->原始位置的路徑中會出現“passthrough http host header to origin”功能。此功能不是“使所有請求返回到源”，而是“將主機標頭信息發送到源”。`,
  'cdnResources.detail.tabKey2.IgnoreSetCookie.name': '緩存 Set-Cookie',
  'cdnResources.detail.tabKey2.SkipSetCookie.name': '跳過 set-cookie',
  // 'cdnResources.detail.tabKey2.IgnoreSetCookie.p1':
  //   'CDN為會話跟蹤設置cookie。我們的CDN不緩存帶有Set-Cookie響應標頭的任何內容，包括JPEG文件等靜態內容。如果因此導致緩存命中率為0%，請啟用此設置，以便緩存此類響應。',
  'cdnResources.detail.tabKey2.IgnoreSetCookie.p1':
    '我們的CDN不緩存帶有Set-Cookie響應標頭的任何內容，包括JPEG等靜態內容，如果因此導致緩存命中率0%，請啟用此設置，一邊緩存此類響應。緩存Set-Cookie的相關內容可以參考',
  'cdnResources.detail.tabKey2.IgnoreSetCookie.p2': '此處文檔。',
  'cdnResources.detail.tabKey2.HTTPSRedirect.name': 'HTTPS重定向',
  'cdnResources.detail.tabKey2.HTTPSRedirect.p1':
    '返回從http地址到https地址的301重定向響應，而不是從緩存或上遊加載。',
  'cdnResources.detail.tabKey2.StreamingMedia.name': '流媒體',
  'cdnResources.detail.tabKey2.StreamingMedia.MP4': 'MP4偽流',
  'cdnResources.detail.tabKey2.StreamingMedia.FLV': 'FLV偽流媒體',
  'cdnResources.detail.tabKey2.StreamingMedia.HLS': 'HLS優化',
  'cdnResources.detail.tabKey2.StreamingMedia.HLS.p1': '如果您想創建強製緩存過期的規則，可以在',
  'cdnResources.detail.tabKey2.StreamingMedia.HLS.p2': '頁面的緩存規則部分快速啟用。',

  'cdnResources.detail.tabKey2.Websocket': 'Websocket',
  'cdnResources.detail.tabKey2.Websocket.Enable': '開啟 Websocket',
  'cdnResources.detail.tabKey2.Websocket.title1': '服務範圍',
  'cdnResources.detail.tabKey2.Websocket.title1.1': '允許所有來源的域名訪問Websocket服務',
  'cdnResources.detail.tabKey2.Websocket.title1.2': '僅允許名單內的域名訪問Websocket服務',
  'cdnResources.detail.tabKey2.Websocket.title1.2.placeholder': '（多域名需要換行填寫）',
  'cdnResources.detail.tabKey2.Websocket.title1.2.message': '請填寫有效的域名',
  'cdnResources.detail.tabKey2.Websocket.title2': '來源信息',
  'cdnResources.detail.tabKey2.Websocket.title2.1.0': '選中後，收到請求時將傳遞參數',
  'cdnResources.detail.tabKey2.Websocket.title2.1.1': ' "Origin" ',
  'cdnResources.detail.tabKey2.Websocket.title2.1.2': '到源',
  'cdnResources.detail.tabKey2.Websocket.title2.2': '指定參數用於傳遞源信息',

  'cdnResources.detail.tabKey3.header1': '亞太地區',
  'cdnResources.detail.tabKey3.header2': '中東',
  'cdnResources.detail.tabKey3.header3': '歐洲',
  'cdnResources.detail.tabKey3.header4': '北美地區',
  'cdnResources.detail.tabKey3.header5': '南美地區',
  'cdnResources.detail.tabKey3.header6': '非洲地區',
  'cdnResources.detail.tabKey3.text1': '矽谷',
  'cdnResources.detail.tabKey3.text2': '邁阿密',
  'cdnResources.detail.tabKey3.text3': '華盛頓',
  'cdnResources.detail.tabKey3.text4': '聖保羅',
  'cdnResources.detail.tabKey3.text5': '法蘭克福',
  'cdnResources.detail.tabKey3.text6': '迪拜',
  'cdnResources.detail.tabKey3.text7': '新加坡',
  'cdnResources.detail.tabKey3.text8': '胡誌明市',
  'cdnResources.detail.tabKey3.text9': '香港',
  'cdnResources.detail.tabKey3.text10': '東京',
  'cdnResources.detail.tabKey3.text11': '利雅得',
  'cdnResources.detail.tabKey3.text12': '開羅',
  'cdnResources.detail.tabKey3.text13': '倫敦',
  'cdnResources.detail.tabKey3.text14': '馬賽',
  'cdnResources.detail.tabKey3.text15': '曼谷',
  'cdnResources.detail.tabKey3.text16': '馬尼拉',
  'cdnResources.detail.tabKey3.text17': '河內',
  'cdnResources.detail.tabKey3.text18': '金邊',
  'cdnResources.detail.tabKey3.text19': '馬斯喀特',
  'cdnResources.detail.tabKey3.text20': '約翰內斯堡',
  'cdnResources.detail.tabKey3.text21': '巴林',
  'cdnResources.detail.tabKey3.Panel1': '亞太地區',
  'cdnResources.detail.tabKey3.Panel1.p1': '香港，中國',
  'cdnResources.detail.tabKey3.Panel1.p2': '東京，日本',
  'cdnResources.detail.tabKey3.Panel1.p3': '新加坡',
  'cdnResources.detail.tabKey3.Panel1.p4': '曼谷，泰國',
  'cdnResources.detail.tabKey3.Panel1.p5': '馬尼拉，菲律賓',
  'cdnResources.detail.tabKey3.Panel1.p6': '河內，越南',
  'cdnResources.detail.tabKey3.Panel1.p7': '金邊，柬埔寨',
  'cdnResources.detail.tabKey3.Panel2': '中東地區',
  'cdnResources.detail.tabKey3.Panel2.p1': '迪拜，阿拉伯聯合酋長國',
  'cdnResources.detail.tabKey3.Panel2.p2': '利雅得，沙特阿拉伯',
  'cdnResources.detail.tabKey3.Panel2.p3': '馬斯喀特，阿曼',
  'cdnResources.detail.tabKey3.Panel2.p4': '巴林',
  'cdnResources.detail.tabKey3.Panel3': '歐洲',
  'cdnResources.detail.tabKey3.Panel3.p1': '法蘭克福，德國',
  'cdnResources.detail.tabKey3.Panel3.p2': '倫敦，英國',
  'cdnResources.detail.tabKey3.Panel3.p3': '馬賽，法國',
  'cdnResources.detail.tabKey3.Panel4': '北美',
  'cdnResources.detail.tabKey3.Panel4.p1': '矽谷，美國',
  'cdnResources.detail.tabKey3.Panel4.p2': '華盛頓，美國',
  'cdnResources.detail.tabKey3.Panel5': '南美地區',
  'cdnResources.detail.tabKey3.Panel5.p1': '聖保羅，巴西',
  'cdnResources.detail.tabKey3.Panel6': '非洲地區',
  'cdnResources.detail.tabKey3.Panel6.p1': '開羅，埃及',
  'cdnResources.detail.tabKey3.Panel6.p2': '約翰內斯堡，南非',
  'cdnResources.detail.tabKey4.tip':
    '清除工具允許您立即從所有數據中心刪除緩存內容。您可以使用特定路徑單獨清除文件，也可以一次清除所有文件。',
  'cdnResources.detail.tabKey4.tip.0': '你也可以選擇使用API進行操作，API地址以及API密鑰請前往',
  'cdnResources.detail.tabKey4.tip.1': '賬號管理',
  'cdnResources.detail.tabKey4.tip.2': '中查看。',
  'cdnResources.detail.tabKey4.Radio1': '清除所有文件',
  'cdnResources.detail.tabKey4.Radio2': '清除特定文件',
  'cdnResources.detail.tabKey4.Radio3': '清除特定目錄',
  'cdnResources.detail.tabKey4.Radio3.0': 'URL目錄',
  'cdnResources.detail.tabKey4.Prefetch.placeholder':
    'https://www.example.com/（多路徑需要換行填寫）',
  'cdnResources.detail.tabKey4.Radio2.purgeFiles.placeholder':
    'https://www.example.com/images/image01.png（多路徑需要換行填寫）',
  'cdnResources.detail.tabKey4.Radio2.purgePaths.message': '請輸入清除路徑',
  'cdnResources.detail.tabKey4.Radio2.purgePaths.placeholder':
    'https://www.example.com/images/（多路徑需要換行填寫）',
  'cdnResources.detail.tabKey4.Radio2.purgePaths.Button': '清除特定文件',
  'cdnResources.detail.tabKey4.Radio2.errorMsg':
    '無效格式。支持 "https://www.example.com/images/image01.png"。',
  'cdnResources.detail.tabKey4.Radio3.errorMsg':
    '無效格式。支持  "https://www.example.com/images/".',
  'cdnResources.detail.tabKey4.ProCard.title': '清除日誌',
  'cdnResources.detail.tabKey4.ProCard.inprocess': '清除中...',
  'cdnResources.detail.tabKey4.ProCard.subTitle': '（僅保存3個月的日誌數據）',
  'cdnResources.detail.tabKey4.ProCard.Option1': '所有日誌',
  'cdnResources.detail.tabKey4.ProCard.Option2': '清除所有文件',
  'cdnResources.detail.tabKey4.ProCard.Option3': '清除特定文件',
  'cdnResources.detail.tabKey4.columns.purgePaths.Button': '查看文件路徑',
  'cdnResources.detail.tabKey4.selected.message': '請確保你至少選擇了一個邊緣位置加速。',
  'cdnResources.detail.tabKey4.Modal.title': '文件路徑',
  'cdnResources.detail.tabKey4.Modal.text': '所有文件',

  'cdnResources.detail.tabKey4.ModalPurge.title': '清除所有文件',
  'cdnResources.detail.tabKey4.ModalPurge.text':
    '如果您選擇清除所有文件，我們將再次從您的源中提取文件。是否確實要清除所有緩存？',
  'cdnResources.detail.tabKey4.ModalPurge.button': '是的，我確定。',
  'cdnResources.detail.tabKey4.Modal.node.title': '加速節點列表',
  'cdnResources.detail.tabKey4.Modal.node.tip': '保存後，你將加速的節點為：',
  'cdnResources.detail.tabKey4.operateResult.COMPLETED': '完成',
  'cdnResources.detail.tabKey4.operateResult.IN_PROCESS': '進行中',
  'cdnResources.detail.tabKey4.operateResult.FAILED': '失敗',

  'cdnResources.detail.tabKey5.onSuccess.message': '提交成功',
  'cdnResources.detail.tabKey5.tip': `預存允許您將新添加的內容預填充到CDN緩存中。這是如果你最近上傳了一個大文件到你的服務器上，特別有用，因為您可以快速提示緩存服務器獲取該文件並強製它們緩存該文件`,
  'cdnResources.detail.tabKey5.Form.prefetchPaths.message': '請輸入預存路徑',
  'cdnResources.detail.tabKey5.Form.prefetchPaths.Button': '預存特定路徑',
  'cdnResources.detail.tabKey5.Prefetchlog.title': '預存日誌',
  'cdnResources.detail.tabKey5.Prefetchlog.inprocess': '預存中...',
  'cdnResources.detail.tabKey5.validatorPaths.message00': '多行文本不能超過 10 行',
  'cdnResources.detail.tabKey5.validatorPaths.message01': '域名長度不超過 250 個字符',
  'cdnResources.detail.tabKey5.validatorPaths.message0':
    '無效URL，URL必須以http(s)://開頭，且域名屬於已配置的加速域名。',
  'cdnResources.detail.tabKey5.validatorPaths.message1':
    '無效URL，URL必須以http(s)://開頭的完整路徑，且域名屬於已配置的加速域名。',
  'cdnResources.detail.tabKey5.validatorPaths.message2':
    '無效URL，當前未配置有效SSL證書，只可預熱http前綴的加速域名。',
  'cdnResources.detail.tabKey6.title1': '用CNAME配置',
  'cdnResources.detail.tabKey6.text1': '通過DNS加速所有靜態文件。',
  'cdnResources.detail.tabKey6.text2': '1.您可以在您的域名服務商處添加CNAME',
  'cdnResources.detail.tabKey6.text3': '加速域名：',
  'cdnResources.detail.tabKey6.text4': 'CNAME：',
  'cdnResources.detail.tabKey6.text4.tip':
    '請註意，cname域名將不再開放直接访问的權限。這將保證所有用戶的安全性。',
  'cdnResources.detail.tabKey6.text5': '2.DNS生成需要一些時間。您可以使用以下工具檢查DNS',
  'cdnResources.detail.tabKey6.text6': '狀態：',
  'cdnResources.detail.tabKey6.text7': '3.這就完成了！',
  'cdnResources.detail.tabKey6.text8': '開始您的LightCDN CDN之旅！如果您有任何其他問題，請聯系我們',
  'cdnResources.detail.tabKey6.text9': '客服',
  'cdnResources.detail.tabKey6.title2': '不用CNAME配置',
  'cdnResources.detail.tabKey6.title11': '簡單的設置，只需更新指向靜態文件的URL。',
  'cdnResources.detail.tabKey6.title12':
    '1.更改需要CDN加速的每個文件（圖像、視頻、CSS等）的源路徑：',
  'cdnResources.detail.tabKey6.title13': '不用CDN：',
  'cdnResources.detail.tabKey6.title14': '用CDN：',
  'cdnResources.detail.tabKey6.text15': '2.這就完成了！',
  //v1.3.3
  'cdnResources.detail.tabKey6.ActivateDiagnosis.imgText': '點擊診斷，自助查詢域名加速情況',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.url.placeholder': '填寫可訪問的路徑',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.btnText': '診斷',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.reBtnText': '重新診斷',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.status.success': '正常運行',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.status.error': '錯誤警告',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.status.warn': '有異常',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.btnTimeText': '最近診斷時間：',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.1': '解析正常',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.2': '未解析',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.3': '解析异常',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.text.3.tip': '其未解析到正確的地址',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step1.name': 'DNS解析',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.text.1': '已配置',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.text.2': '未配置',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.textTo': '前往配置',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step2.name': 'SSL证书',
  // 'cdnResources.detail.tabKey6.ActivateDiagnosis.step3.text': '500',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step3.name': '页面状态',
  // 'cdnResources.detail.tabKey6.ActivateDiagnosis.step4.text': "",
  'cdnResources.detail.tabKey6.ActivateDiagnosis.step4.name': '加速情况',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.testPlace': '測試地區',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.testDomain': '測試域名',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.invalidURL': '無效URL，該路徑不存在',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.moreTip':
    '不是這個問題？ 查看更多常見問題，對應處理 →',
  'cdnResources.detail.tabKey6.ActivateDiagnosis.TLS13': 'TLS1.3 暫不支持診斷',

  'cdnResources.detail.tabKey7.title': '訪問保護',
  'cdnResources.detail.tabKey7.accessCountry.name': '國家白名單',
  'cdnResources.detail.tabKey7.CountryAccess.p1':
    '配置規則以啟用/禁用對指定國家/地區CDN資源內容的訪問。',
  'cdnResources.detail.tabKey7.CountryAccess.p2': '你{val}有訪問，除了部分國家。 ',
  'cdnResources.detail.tabKey7.clickHere': '點擊此處查看列表。',
  'cdnResources.detail.tabKey7.countries.title': '（以下國家/地區除外）', //，可不填寫
  'cdnResources.detail.tabKey7.accessHotlink.name': 'URL白名單',
  'cdnResources.detail.tabKey7.hotlinkPolicy.p1':
    '配置一個規則，以啟用/禁用對指定URL的CDN資源內容的訪問。',
  'cdnResources.detail.tabKey7.hotlinkPolicy.p2': '你{val}訪問，除了部分域名。',
  'cdnResources.detail.tabKey7.hotlinkPolicy.p3': '（CDN加速域名將被默認添加。）',
  'cdnResources.detail.tabKey7.domians.title': '（以下域名除外）', //，可不填寫
  'cdnResources.detail.tabKey1.domians.message': '請输入域名！',
  'cdnResources.detail.tabKey1.domians.placeholder':
    'www.example.com/*.example.com（多個域名需要換行填寫。）',
  'cdnResources.detail.tabKey7.accessIp.name': 'IP白名單',
  'cdnResources.detail.tabKey7.IPAccess.p1':
    '配置一個規則，以啟用/禁用對一系列IP地址（包括IPv4和IPv6）的CDN資源內容的訪問。',
  'cdnResources.detail.tabKey7.IPAccess.p2': '你{val}，除了部分IP地址。',
  'cdnResources.detail.tabKey7.addresses.title': '（以下IP地址除外）', //，可不填寫
  'cdnResources.detail.tabKey1.addresses.message': '請輸入IP地址！',
  'cdnResources.detail.tabKey1.addresses.placeholder':
    '10.10.10.10\n20.20.20.0/24\n2001:CDBA::64\n...',
  'cdnResources.detail.tabKey7.urlSigningVO.name': 'URL簽名',
  'cdnResources.detail.tabKey7.URLSigning.p1': '使用密鑰保護您的文件免受未經授權的訪問。',
  'cdnResources.detail.tabKey7.signingKey.title': 'URL簽名秘鑰',
  'cdnResources.detail.tabKey7.URLSigning.Generate': '生成一個新的',
  'cdnResources.detail.tabKey7.URLSigning.message': '請輸入6-32的字符串，不支持空格。',
  'cdnResources.detail.tabKey7.URLSigning.validatorMessage': 'URL簽名密鑰無效。',
  'cdnResources.detail.tabKey7.URLSigning.form.Param': '參數',
  'cdnResources.detail.tabKey7.URLSigning.form.Value': '值',
  'cdnResources.detail.tabKey7.URLSigning.form.Key': '秘鑰',
  'cdnResources.detail.tabKey7.URLSigning.form.Param.pop':
    '默認值為「sign」,如果你的加密串是其他的參數，請填寫。',
  'cdnResources.detail.tabKey7.URLSigning.form.TTL.pop':
    '鏈接的有效時間。由於URL鑒權是動態生成URL的，所以鏈接所在的頁面的緩存時間設置不能超過鑒權設置的有效時間。',
  'cdnResources.detail.tabKey7.crawlers.name': '阻止搜索引擎爬網程序',
  'cdnResources.detail.tabKey7.crawlers.p1':
    '阻止搜索引擎爬網程序用於阻止網絡爬網機器人對CDN內容進行索引。',
  'cdnResources.detail.tabKey7.Modal.here.title': '{name}列表',
  'cdnResources.detail.tabKey7.Modal.here.tip': '你{val}，除了：',
  'cdnResources.detail.tabKey7.SafetyWaf.name': 'OWASP最大威脅',
  'cdnResources.detail.tabKey7.SafetyWaf.title': 'WAF',
  'cdnResources.detail.tabKey7.SafetyWaf.tip1': '如果您不知道OWSAP的具體定義，可以查看',
  'cdnResources.detail.tabKey7.SafetyWaf.tip2': '文檔',
  'cdnResources.detail.tabKey7.SafetyWaf.tip3': '去了解。',
  'cdnResources.detail.tabKey7.URLSigning.pop1': '安全令牌由以下參數組成：',
  'cdnResources.detail.tabKey7.URLSigning.pop2':
    'Expires — URL的到期時間或URL變得無效的時間。時間以Unix時間戳格式在URL中傳遞，並參與哈希生成。它是一個可選參數。',
  'cdnResources.detail.tabKey7.URLSigning.pop3': 'Path — 文件路徑或文件目錄',
  'cdnResources.detail.tabKey7.URLSigning.pop4': 'Key — 一個URL簽名秘鑰',
  'cdnResources.detail.tabKey7.URLSigning.pop5':
    'IP— 提供訪問的IP。它是可選的，每次生成哈希鍵時只允許使用一個IP。',
  'cdnResources.detail.tabKey7.URLSigning.pop6': 'URL簽名可以采用以下格式之一：',
  'cdnResources.detail.tabKey7.URLSigning.pop7':
    '查詢字符串格式：http://example.com/filename?secure=DMF1ucDxtqgxwYQ&expires=1546300800&ip=1.2.3.4',
  'cdnResources.detail.tabKey7.URLSigning.pop8':
    '路徑格式：http://example.com/secure=DMF1ucDxtqgxwYQ&expires=1546300800&ip=1.2.3.4/filename',
  'cdnResources.detail.tabKey7.Access.label1': '未開啟',
  'cdnResources.detail.tabKey7.Access.label2': '默認開啟所有',
  'cdnResources.detail.tabKey7.Access.label3': '默認阻止所有',
  'cdnResources.detail.tabKey7.allowed': '默認開啟所有',
  'cdnResources.detail.tabKey7.block': '默認阻止所有',
  'cdnResources.detail.tabKey7.disabled': '未開啟',
  'cdnResources.detail.tabKey7.SafetyNginx.title': 'Nginx設置',
  'cdnResources.detail.tabKey7.SafetyNginx.title1': '速率設置',
  'cdnResources.detail.tabKey7.SafetyNginx.title2': '緩存鍵',
  'cdnResources.detail.tabKey7.SafetyNginx.text1': '支持限製客戶每個請求的相應速度。',
  'cdnResources.detail.tabKey7.SafetyNginx.text2': '當前設置：當請求達到了',
  'cdnResources.detail.tabKey7.SafetyNginx.text3': '，響應速度將降至',
  'cdnResources.detail.tabKey7.SafetyNginx.text4': '支持從四種類型的緩存鍵中選擇一種進行緩存。',
  'cdnResources.detail.tabKey7.SafetyNginx.message': '請不要超過2T。',
  // v1.1.13
  'cdnResources.detail.tabKey8.tabs1': '緩存規則',
  'cdnResources.detail.tabKey8.tabs2': '重定向規則',
  'cdnResources.detail.tabKey8.tabs3': '修改標頭',
  'cdnResources.detail.tabKey8.tabs3.1': '請求標頭',
  'cdnResources.detail.tabKey8.tabs3.2': '響應標頭',
  'cdnResources.detail.tabKey8.tabs3.3': '在請求標頭中獲取客戶端IP',
  'cdnResources.detail.tabKey8.tabs3.header': '標頭',
  'cdnResources.detail.tabKey8.tabs3.Edit.succeeded': '編輯成功',
  'cdnResources.detail.tabKey8.tabs4': '源規則',
  'cdnResources.detail.tabKey8.tabs.tip0': '如何繞過 LightCDN 的邊緣服務器直接訪問源呢？',
  'cdnResources.detail.tabKey8.tabs.tip1': '通過CDN訪問源站提示重定向的次數過多？',
  'cdnResources.detail.tabKey8.tabs.tip2': '來看看如何解決吧！→',
  'cdnResources.detail.tabKey8.tabs.tip3': '來看看如何解決吧！→',
  'cdnResources.detail.tabKey8.tabs1.create': '創建一條新的規則', // {num}
  'cdnResources.detail.tabKey8.tabs1.p1': '自定義HTTP緩存規則。 ',
  'cdnResources.detail.tabKey8.tabs1.p2': '閱讀文檔來了解更多。',
  'cdnResources.detail.tabKey8.tabs1.p3.1': '你當前可以創建',
  'cdnResources.detail.tabKey8.tabs1.p3.2': '條規則。',
  'cdnResources.detail.tabKey8.tabs1.p3.3': '去購買更多的規則。',
  'cdnResources.detail.tabKey8.tabs1.p4': '去購買更多的規則。',
  'cdnResources.detail.tabKey8.tabs1.table.title1': '名稱',
  'cdnResources.detail.tabKey8.tabs1.table.title2': '選項',
  'cdnResources.detail.tabKey8.tabs1.table.compensation': '系統補償',
  'cdnResources.detail.tabKey8.tabs1.form.title1.message': '請輸入名稱！',
  'cdnResources.detail.tabKey8.tabs1.form.title1.exists': '規則名稱已存在。',
  'cdnResources.detail.tabKey8.tabs1.form.title1.invalidName': '无效名称，請输入字母或数字。',
  'cdnResources.detail.tabKey8.tabs1.form.invalidName': '無效名稱',
  'cdnResources.detail.tabKey8.tabs1.form.title1.cnMessage': '請輸入字母或數字。',
  'cdnResources.detail.tabKey8.tabs1.form.title1.button': '生成一個名稱',
  'cdnResources.detail.tabKey8.tabs1.form.title2': '條件（傳入請求匹配…時）',
  'cdnResources.detail.tabKey8.tabs1.form.title3': '操作（然後…）',
  'cdnResources.detail.tabKey8.tabs1.form.title4': '動作',
  'cdnResources.detail.tabKey8.tabs1.form.title4.message': '請選擇動作',
  'cdnResources.detail.tabKey8.tabs1.form.title4.message1': '請至少選擇一個動作開啟。',
  'cdnResources.detail.tabKey8.tabs1.form.title5': '從不緩存',
  'cdnResources.detail.tabKey8.tabs1.form.title6': '緩存',
  'cdnResources.detail.tabKey8.tabs1.form.title7': '強製邊緣從不緩存',
  'cdnResources.detail.tabKey8.tabs1.form.title8': '強製客戶端從不緩存',
  'cdnResources.detail.tabKey8.tabs1.form.title9': '強製邊緣緩存',
  'cdnResources.detail.tabKey8.tabs1.form.title10': '強製客戶端緩存',
  'cdnResources.detail.tabKey8.tabs1.form.title11': '覆蓋默認緩存有效性',
  'cdnResources.detail.tabKey8.tabs1.form.title12': 'TTL',
  'cdnResources.detail.tabKey8.tabs1.form.title12.message': '請輸入TTL',
  'cdnResources.detail.tabKey8.tabs1.form.title7.text':
    '強製CDN邊緣服務器從不緩存請求。但是，如果請求已經緩存（例如，如果它是在設置此規則之前緩存的），則不會強製將其從緩存中取出。',
  'cdnResources.detail.tabKey8.tabs1.form.title8.text':
    '強製客戶端從不緩存請求。這是通過刪除所有「Cache-Control」和「Expires」響應標頭來實現的，而非發送「Cache-Control: no-cache」。',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text':
    '強製CDN邊緣服務器將請求緩存指定的持續時間。這將覆蓋來自源的任何「Cache-Control」或「Expires」標頭，即使它們指定了「private」或「no-cache」。',
  'cdnResources.detail.tabKey8.tabs1.form.title9.second':
    '這將覆蓋來自源的任何「Cache-Control」或「Expires」標頭，即使它們指定了「private」或「no-cache」。值必須填寫1min或更長。',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text.0':
    '強製CDN邊緣服務器將請求緩存指定的持續時間。這個功能適用於',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text.1': '內容更新不頻繁',
  'cdnResources.detail.tabKey8.tabs1.form.title9.text.2': '的業務場景。',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.0':
    '強製客戶端將請求緩存指定的持續時間。這個功能適用於',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.1': '內容需要頻繁更新',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.2': '的業務場景。',
  'cdnResources.detail.tabKey8.tabs1.form.title10.text.3':
    '這將覆蓋來自源的任何「Cache-Control」或「Expires」標頭，即使它們指定了「private」或「no-cache」。值必須填寫1min或更長。',
  'cdnResources.detail.tabKey8.tabs1.form.title11.text':
    '為未明確指定「Cache-Control」或「Expires」的源響應更改CDN邊緣服務器的默認有效期。具有「Cache Control」或「Expires」標頭的響應仍將被接受。',
  'cdnResources.detail.tabKey8.tabs1.form.item1.name': '條件',
  'cdnResources.detail.tabKey8.tabs1.form.item2.name': '主題',
  'cdnResources.detail.tabKey8.tabs1.form.item3.name': 'Cookie/Param參數/Header標頭',
  'cdnResources.detail.tabKey8.tabs1.form.item3.message': '請输入Cookie/Param参数/Header标头',
  'cdnResources.detail.tabKey8.tabs1.form.item4.name': '謂語',
  'cdnResources.detail.tabKey8.tabs1.form.item5.name': '值',
  'cdnResources.detail.tabKey8.tabs1.form.item5.message': '請输入值',
  'cdnResources.detail.tabKey8.tabs1.form.create': '創建一條新的規則',
  'cdnResources.detail.tabKey8.tabs1.form.save': '保存修改',
  'cdnResources.detail.tabKey8.tabs1.form.extensionEqual.tip':
    'Tips: extension的主題允許你一個條件中填入多個拓展名，請用英文字符[,]間隔開拓展名。',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip':
    'Tips: IP的主題允許你一個條件中填入多個IP。當你選擇的是in range，有兩種格式可選擇。',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip.0':
    '（1）開始ip,結束ip ,並英文橫桿[-]隔開。例子： 192.168.1.100-192.168.2.200',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip.1': '（2）CIDR格式。例子：192.168.2.1/24',
  'cdnResources.detail.tabKey8.tabs1.form.IP.tip.2':
    '（3）多個單IP ,並英文逗號[,]隔開。例子：1.1.1.1,2.2.2.2',
  //v1.3.3
  'cdnResources.detail.tabKey8.tabs1.form.url.tip':
    '提示：URL主題的格式應遵循完整的請求URL，包括協議、域名、請求路徑、參數等，類似http://cdn.example.com/image.jpg?name=cdn 。',

  'cdnResources.detail.tabKey8.tabs1.PopoverText1': '編輯',
  'cdnResources.detail.tabKey8.tabs1.PopoverText2': '刪除',
  'cdnResources.detail.tabKey8.tabs1.Delete.content':
    '刪除後，該規則將變為無效。你確定要刪除它嗎？',
  'cdnResources.detail.tabKey8.tabs2.title': '快速開啟配置',
  'cdnResources.detail.tabKey8.tabs2.QuicklyEnable': '快速開啟',
  'cdnResources.detail.tabKey8.tabs2.card.title': 'HTTPS重定向',
  'cdnResources.detail.tabKey8.tabs2.card.p1':
    '返回從http地址到https地址的301重定向響應，而不是從緩存或上遊加載。',
  'cdnResources.detail.tabKey8.tabs2.card.p2':
    '我們將直接為您生成一個規則，並將其顯示在下面的列表中。',
  'cdnResources.detail.tabKey8.tabs2.p1': '創建規則將訪問者從源URL重定向到目標URL。',
  'cdnResources.detail.tabKey8.tabs2.code.name1': '重定向功能',
  'cdnResources.detail.tabKey8.tabs2.code.name2': '規則列表',
  'cdnResources.detail.tabKey8.tabs2.code.title': '全站重定向',
  'cdnResources.detail.tabKey8.tabs2.code.p':
    '請註意，開啟全站重定向後，該規則將優先於其他規則，訪問到加速域名的所有請求都將自動跳轉至你設置的域名。填寫的URL若不包含前綴，http/https，將默認保持協議。',
  'cdnResources.detail.tabKey8.tabs2.code.col.1': '跳轉後的URL',
  'cdnResources.detail.tabKey8.tabs2.code.col.message': '請輸入跳轉後的URL',
  'cdnResources.detail.tabKey8.tabs2.code.col.2': '狀態碼',
  'cdnResources.detail.tabKey8.tabs2.code.col.302': '302 - 臨時重定向',
  'cdnResources.detail.tabKey8.tabs2.code.col.301': '301 - 永久重定向',
  'cdnResources.detail.tabKey8.tabs2.form.title1': '禁止訪問客戶端',
  'cdnResources.detail.tabKey8.tabs2.form.title2': '設置重定向',
  'cdnResources.detail.tabKey8.tabs2.form.title3': '將客戶端從HTTP重定向到HTTPs',
  'cdnResources.detail.tabKey8.tabs2.form.title4': '重定向客戶端',
  'cdnResources.detail.tabKey8.tabs2.form.title5': 'URL',
  'cdnResources.detail.tabKey8.tabs2.form.title5.message': '請輸入URL',
  'cdnResources.detail.tabKey8.tabs2.form.title1.text': '向客戶端返回一個簡單的403 Forbidden響應。',
  'cdnResources.detail.tabKey8.tabs2.form.title2.text':
    '返回從http地址到https地址的301重定向響應，而不是從緩存或上遊加載。',
  'cdnResources.detail.tabKey8.tabs2.form.title2.text.1': '資源存在多個加速域名時，需要選定一個。',
  'cdnResources.detail.tabKey8.tabs2.form.title3.text':
    '將302重定向響應返回到客戶端的指定URL。這將作用於所有的加速域名。填寫的URL若不包含前綴，',
  'cdnResources.detail.tabKey8.tabs2.form.title3.text1': '，將默認保持協議。',
  'cdnResources.detail.tabKey8.tabs2.form.title3.select.text': '重定向對象',
  'cdnResources.detail.tabKey8.tabs3.p1': '調整邊緣的請求的HTTP標頭。',
  'cdnResources.detail.tabKey8.tabs3.p2': '調整邊緣的響應的HTTP標頭。',
  'cdnResources.detail.tabKey8.tabs3.p2.0':
    '從請求標頭中獲取客戶端IP。必須提供標頭名稱。常見的標頭有',
  'cdnResources.detail.tabKey8.tabs3.p2.1': 'X-Forwarded-For、X-Real-IP、X-Client-IP',
  'cdnResources.detail.tabKey8.tabs3.p2.2': '等。',
  'cdnResources.detail.tabKey8.tabs3.form.title1': '設置請求標頭',
  'cdnResources.detail.tabKey8.tabs3.form.title2': '設置響應標頭',
  'cdnResources.detail.tabKey8.tabs3.form.title3': '在請求標頭中設置客戶端IP',
  'cdnResources.detail.tabKey8.tabs3.form.title1.create': '創建请求标头',
  'cdnResources.detail.tabKey8.tabs3.form.title2.create': '創建响应标头',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Header': '標頭',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Header.message': '請輸入標頭',
  'cdnResources.detail.tabKey8.tabs3.form.title1.HeaderValue.message': '請輸入標頭和值',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Value': '值',
  'cdnResources.detail.tabKey8.tabs3.form.title1.Value.message': '請輸入值',
  'cdnResources.detail.tabKey8.tabs3.form.title1.text':
    '將請求標頭覆蓋到源。必須提供標頭名稱和標頭值。',
  'cdnResources.detail.tabKey8.tabs3.form.title2.text':
    '覆蓋客戶端的響應標頭。必須提供標頭名稱和標頭值。',
  'cdnResources.detail.tabKey8.tabs3.form.title3.text':
    '將請求標頭中客戶端的IP地址設置為源。必須提供標頭名稱。',
  'cdnResources.detail.tabKey8.tabs3.form.title4.text':
    '將響應頭覆蓋到源。必須提供標頭名稱和標頭值。',
  'cdnResources.detail.tabKey8.tabs4.p1': '自定義原始配置請求的目的地。',
  'cdnResources.detail.tabKey8.tabs4.form.title1': '準備源目錄',
  'cdnResources.detail.tabKey8.tabs4.form.title2': '設置自定義源',
  'cdnResources.detail.tabKey8.tabs4.form.title3': '將HTTP主機頭傳遞到源',
  'cdnResources.detail.tabKey8.tabs4.form.title4': '其他設置',
  'cdnResources.detail.tabKey8.tabs4.form.title1.text':
    '邊緣服務器從源位置請求時，將目錄設置為預先準備的URL。',
  'cdnResources.detail.tabKey8.tabs4.form.title2.text': '替代邊緣服務器連接到源。',
  'cdnResources.detail.tabKey8.tabs4.form.title3.text':
    '當條件為true時，返回原點，在第一次期間，並且隨後的請求（緩存在邊緣中）將不會再次返回原點，盡管條件為true。',
  'cdnResources.detail.tabKey8.InvalidFormat': '無效格式',
  'cdnResources.detail.tabKey8.tabs4.title.1': '回源主機名',
  'cdnResources.detail.tabKey8.tabs4.title.1.0':
    '回源主機名的選擇影響到請求源站時接收到的域名。默認是CDN加速域名。還是不了解回源主機名，',
  'cdnResources.detail.tabKey8.tabs4.title.1.0.0': '點擊查看更詳細的內容→',
  'cdnResources.detail.tabKey8.tabs4.title.1.1.0':
    '跟隨CDN域名："跟隨CDN域名"是指源站接收到的域名和當前CDN加速域名保持一致。這種類型基本用於',
  'cdnResources.detail.tabKey8.tabs4.title.1.1.1': '源站支持多域名托管',
  'cdnResources.detail.tabKey8.tabs4.title.1.1.2': '的情况，精準匹配請求，避免404/400錯誤。',
  'cdnResources.detail.tabKey8.tabs4.title.1.2.0':
    '跟隨源站：跟隨源站"是指源站接收到的域名仍然是填寫的源站地址中的信息，不隨代理服務域名改變而改變。',
  'cdnResources.detail.tabKey8.tabs4.title.1.2.1': '多用於源站僅服務單一域名',
  'cdnResources.detail.tabKey8.tabs4.title.1.2.2': '，兼容性好，無需修改源站配置。',
  'cdnResources.detail.tabKey8.tabs4.title.1.3': '自定義：自定義Host內容中支持請求變量。',
  'cdnResources.detail.tabKey8.tabs4.title.1.type1': '跟隨CDN域名',
  'cdnResources.detail.tabKey8.tabs4.title.1.type2': '跟隨源站',
  'cdnResources.detail.tabKey8.tabs4.title.1.type3': '自定義',
  'cdnResources.detail.tabKey8.tabs4.title.2': '準備源目錄',
  'cdnResources.detail.tabKey8.tabs4.title.2.0':
    '當邊緣服務器從源請求時，將目錄設置為預先準備的URL。比如值為',
  'cdnResources.detail.tabKey8.tabs4.title.2.00': '「images」',
  'cdnResources.detail.tabKey8.tabs4.title.2.1': '，客戶端向邊緣服務器請求：',
  'cdnResources.detail.tabKey8.tabs4.title.2.10': '「http://cdn.example.com/photo.jpg」',
  'cdnResources.detail.tabKey8.tabs4.title.2.2': '， 邊緣服務器向源請求：',
  'cdnResources.detail.tabKey8.tabs4.title.2.20': '「http://cdn.example.com/images/photo.jpg」。',
  'cdnResources.detail.tabKey8.tabs4.title.3': '自動添加標頭',
  'cdnResources.detail.tabKey8.tabs4.title.3.0':
    '選中後，會自動向源站請求添加這些報頭，以便於源站獲取客戶端信息。',

  'cdnResources.detail.tabKey8.tabs4.RequestLimiting': '請求限製',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.1': '最大並發數',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.1.0':
    '當前網站的最大並發出，超過此限製將會以 429 狀態碼的結果返回給用戶。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.1.1': '值為0表示沒有限製。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.2': '每個IP的最大並發數',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.2.0':
    '每個IP的最大並發數。統計單IP的總連接數時，不區分網站。如果超過限製，將會以 429 狀態碼的結果返回給用戶。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.2.1': '值為0表示沒有限製。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.3': '每個請求的帶寬限製',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.3.0': '客戶端單個請求每秒可以讀取的下行流量。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.3.1': '可以為空。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.4': '每個請求的最大內容大小',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.4.0': '單個請求能發送的最大內容大小。',
  'cdnResources.detail.tabKey8.tabs4.RequestLimiting.4.1': '可以為空。',
  'cdnResources.detail.tabKey8.tabs4.EnabledMode': ' 啟用模式',
  'cdnResources.detail.tabKey8.tabs4.CurrentSetting': '當前設置：',
  'cdnResources.detail.tabKey8.tabs4.Unlimited': '不限製',
  //v1.3.6
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title': 'CC防護',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title1': '防護設定',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title2': '訪問統計',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title3': '被攔截IP',
  'cdnResources.detail.tabKey8.tabs5.CCprotection.title4': 'CC白名單',
  'cdnResources.detail.tabKey8.tabs6.5SShield.title': '5秒盾',
  'cdnResources.detail.tabKey8.tabs5.CCSet.title': '防護設定',
  'cdnResources.detail.tabKey8.tabs5.CCSet.text': '開啟CC防護',
  'cdnResources.detail.tabKey8.tabs5.CCSet.tip1': '不知道什麼是CC防護？',
  'cdnResources.detail.tabKey8.tabs5.CCSet.tip2': '該如何使用，前往查看 →',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1': '攔截閾值',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text1':
    '自動 - 將根據網站訪問量自動動態設定閾值，推薦大多數場景。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text2':
    '默認 - 使用預設安全值，適合流量較為穩定的業務。當前系統默認閾值設定：單IP 每 5 秒 最多 60 請求； 每 60 秒 最多 150 請求； 每 300 秒 最多 300 請求。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text3': '自定義 - 手動設定，需熟悉業務流量。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content1': '單IP每5秒最多',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content2': '單IP每60秒最多',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content3': '單IP每300秒最多',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav1.text.content4': '請求',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav2': '攔截強度',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav2.text': '級別越高，被攔截的IP封禁時間越長。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav3': '忽略常用檔案',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav3.text':
    '忽略js、css、jpg等常在網頁裡被引用的檔案名，即對這些檔案的訪問不加入計數，可以減少誤判機率。但如果單獨訪問這些檔案，比如在瀏覽器裡直接打開，也會加入計數。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav4': '檢查請求來源指紋',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav4.text':
    '在接收到HTTPS請求時嘗試檢查請求來源的指紋，用來檢測代理服務和爬蟲攻擊；如果你在網站前面放置了別的反向代理服務，請取消此選項。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav5': 'GET302校驗',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav5.text':
    '開啟後，表示自動通過GET302方法來校驗用戶端。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6': '檢測閾值',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6.text':
    '當某個IP在1分鐘內平均QPS達到此值時，才會開始檢測；為0，表示任何訪問都會檢測。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6.text.content1': '單IP最低QPS',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav6.text.content2': '請求數/秒',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav7': '防護範圍',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav7.text1':
    '填寫名單用於區別特殊配置的內容。當前選擇防護名單，表示只對這些URL進行CC防護。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav7.text2':
    '填寫名單用於區別特殊配置的內容。當前選擇排除名單，表示這些URL跳過CC防護不做處理。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav8': '郵件警告',
  'cdnResources.detail.tabKey8.tabs5.CCSet.nav8.text':
    '開啟後，當有疑似風險或者觸發CC防護自動攔截時，發送郵件警告。',
  'cdnResources.detail.tabKey8.tabs5.CCSet.suggestion': '建議開啟',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.tip1':
    'IP即時訪問量爲最近五分鍾的預估量。拉黑的IP妳可以前往',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.tip2': '攔截IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.tip3': '中查看 →',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column1': 'IP資訊',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column2': '平均訪問量',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column3': '總訪問量',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.column4': '操作',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIP': '拉黑IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.whiteIP': '加入白名單',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item0': 'IP或IP段',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item1': 'IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item2': '自動解除時間',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item3': '備註',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item4': '一鍵選擇：',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item5': '1小時',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item6': '1天',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item7': '3天',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item8': '1周',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item9': '30天',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.item10': '1年',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.defaultReason': '疑似CC攻擊',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.blackIPModal.btn': '新增黑名單IP',
  'cdnResources.detail.tabKey8.tabs5.CCStatistics.Modal.placeholder':
    '10.10.10.10\n20.20.20.0/24\n2001:CDBA::64\n多個請換行，支援IPv4或IPv6',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.column1': '攔截結束時間',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.column2': '攔截原因',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.column3': '請求路徑',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.remove': '解除',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.intercepted': '已攔截',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.title': '解除攔截',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text1': '該IP',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text2': '預計在',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text3': '解除攔截。',
  'cdnResources.detail.tabKey8.tabs5.CCIpBlack.removeModal.text4': '是否確認當前解除攔截?',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.tip': '加入CC白名單的IP，將跳過CC防護的檢測。',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.addButton': '新增CC白名單',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.column1': '類型',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.column2': '建立時間',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.delete': '刪除',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.addButton.btnText': '新增白名單IP',
  'cdnResources.detail.tabKey8.tabs5.CCIpWhite.deleteModal.text': '是否確認從白名單中移除IP',
  'cdnResources.detail.tabKey8.tabs5.SShield.text': '開啟5秒盾',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav1': '驗證有效期',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav1.text':
    '單個用戶端驗證通過後，在這個有效期內不再重複驗證；如果為0則表示系統預設。',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav1.second': '秒',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav2': '單IP最低QPS',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav2.text':
    '當某個IP在1分鐘內平均QPS達到此值時，才會觸發5秒盾；如果設定為0，表示任何訪問都會觸發。',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav3': '加入IP白名單',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav3.text':
    '開啟後，驗證通過的IP將加入臨時白名單，此IP下次訪問時不再校驗5秒盾；此白名單只對5秒盾有效，不影響其他規則。此選項主要用於可能無法正常使用Cookie的網站。',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav4': '防護範圍',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav4.text1':
    '填寫名單用於區別特殊配置的內容。當前選擇防護名單，表示只對這些URL進行5秒盾保護。',
  'cdnResources.detail.tabKey8.tabs5.SShield.nav4.text2':
    '填寫名單用於區別特殊配置的內容。當前選擇排除名單，表示這些URL跳過5秒盾不做處理。',
  'cdnResources.detail.tabKey8.tabs5.enum.threshold.0': '自動',
  'cdnResources.detail.tabKey8.tabs5.enum.threshold.1': '默認',
  'cdnResources.detail.tabKey8.tabs5.enum.threshold.2': '自定義',
  'cdnResources.detail.tabKey8.tabs5.enum.strength.0': '低',
  'cdnResources.detail.tabKey8.tabs5.enum.strength.1': '中',
  'cdnResources.detail.tabKey8.tabs5.enum.strength.2': '高',
  'cdnResources.detail.tabKey8.tabs5.enum.range.0': '未開啟',
  'cdnResources.detail.tabKey8.tabs5.enum.range.1': '防護名單',
  'cdnResources.detail.tabKey8.tabs5.enum.range.2': '排除名單',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0': '萬用字元',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.placeholder':
    '使用星號(*)萬用字元，不區分大小寫',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip0': '萬用字元示例：',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip1': '單個路徑開頭：/hello/world/*',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip2': '單個路徑結尾：*/hello/world',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip3': '包含某個路徑：*/article/*',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip4': '某個網域下的所有URL：*.example.com/*',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.0.tip5': '忽略某個副檔名：*.js',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.1': '常見圖片',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.2': '常見影片',
  'cdnResources.detail.tabKey8.tabs5.enum.rangeList.4': '常見音訊',
  //v1.3.2
  'cdnResources.detail.tabKey9.title1': '頁面優化',
  'cdnResources.detail.tabKey9.title2': '內容壓縮',
  'cdnResources.detail.tabKey9.title3': '緩存優化',
  'cdnResources.detail.tabKey9.PageOptimize.title': '靜態文件優化',
  'cdnResources.detail.tabKey9.PageOptimize.name1': 'HTML優化',
  'cdnResources.detail.tabKey9.PageOptimize.name2': 'Javascript優化',
  'cdnResources.detail.tabKey9.PageOptimize.name3': 'CSS優化',
  'cdnResources.detail.tabKey9.PageOptimize.name1.p':
    '可以自動優化HTML中包含的空白、註釋、空標簽等；只有文件可以緩存時才會被優化。',
  'cdnResources.detail.tabKey9.PageOptimize.name2.p':
    '可以自動縮短Javascript中變量、函數名稱等。只有文件可以緩存時才會被優化。',
  'cdnResources.detail.tabKey9.PageOptimize.name3.p':
    '可以自動去除CSS中包含的空白。只有文件可以緩存時才會被優化。',
  'cdnResources.detail.tabKey9.GzipOptimize.title1': '壓縮算法',
  'cdnResources.detail.tabKey9.GzipOptimize.title2': '圖像算法',
  'cdnResources.detail.tabKey9.GzipOptimize.name1': '壓縮啟用',
  'cdnResources.detail.tabKey9.GzipOptimize.name2': 'WebP',
  'cdnResources.detail.tabKey9.GzipOptimize.name1.p':
    '快速的壓縮算法，支持高壓縮率和實時壓縮性能。壓縮算法的優先級按照排列順序。',
  'cdnResources.detail.tabKey9.GzipOptimize.name2.p':
    '選中後表示開啟自動WebP壓縮；圖片的寬和高均不能超過16383像素；只有緩存的圖片內容才會被轉換；最小緩存時間為：7200秒。',
  'cdnResources.detail.tabKey9.CacheOptimize.title': '緩存條件優化',
  'cdnResources.detail.tabKey9.CacheOptimize.name1': '忽略參數',
  'cdnResources.detail.tabKey9.CacheOptimize.name1.p1':
    '開啟後，生成緩存Key時不包含URI參數，即問號（?）後面的內容。',
  'cdnResources.detail.tabKey9.CacheOptimize.name1.p2': '更多請查看文檔 →',
};
